import RulesTable from './RulesTable';
export default RulesTable;
